export function isWithinRange(a,b,c){return!a||(!b||a>=b)&&(!c||a<=c)}